import axios, { AxiosRequestConfig } from 'axios'

import { IMonitor } from '../types/monitor'

export const getMonitors = async (
  lastId?: number,
  query?: any,
): Promise<[IMonitor[], number]> => {
  const config: AxiosRequestConfig = {}
  if (lastId) {
    config.params.lastId = lastId
  }
  if (query !== undefined) {
    config.params = {
      ...config.params,
      ...query,
    }
  }
  const instance = axios.create(config)
  try {
    const response = await instance.get<IMonitor[]>('monitors')
    const monitors = response.data
    return [monitors, monitors.length]
  } catch (error) {
    console.error(error)
    throw new Error('error.monitors.getMonitors')
  }
}

export const getMonitor = async (id: string): Promise<IMonitor> => {
  const instance = axios.create()
  try {
    const response = await instance.get<IMonitor>(`monitors/${id}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.monitors.getMonitor')
  }
}
